// extracted by mini-css-extract-plugin
module.exports = {"container":"BoostedBusinesses_container__3HPgE","board":"BoostedBusinesses_board__1EwBQ"};